export enum DifficultyLevel {
  EASY = 1,
  MEDIUM = 2,
  HARD = 3,
}
